export default __webpack_public_path__ + "static/media/squarespace.f2f334d4.svg";